// extracted by mini-css-extract-plugin
module.exports = {"term_intro":"Styles_term_intro__AeBFX"};